import { createContext, FC, ReactNode, useContext, useState } from 'react';
import { useStore } from 'zustand';

import {
  createSignUpStore,
  selectCreationEmployeeModel,
  selectIsAllAgree,
  selectIsPossibleSignup,
  selectIsRequiredAllAgree,
  selectSubscribeMarketingEvent,
  SignUpState,
  SignUpStoreApi,
} from '../stores/createSignUpStore';

const SignUpStoreContext = createContext<SignUpStoreApi | null>(null);

export function useSignUpStore<U>(selector: (s: SignUpState) => U): U {
  const api = useContext(SignUpStoreContext);
  if (!api) {
    throw new Error('useSignUpStore must be used within SignUpProvider');
  }
  return useStore(api, selector);
}

export {
  selectCreationEmployeeModel,
  selectIsAllAgree,
  selectIsPossibleSignup,
  selectIsRequiredAllAgree,
  selectSubscribeMarketingEvent,
};

export const SignUpProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [store] = useState(() => createSignUpStore());
  return <SignUpStoreContext.Provider value={store}>{children}</SignUpStoreContext.Provider>;
};
